<template>
  <div>
    <Time
      @toggle="toggle($event)"
      @toStart="seekToStart(time.id)"
      :time="time" :key="time.id" v-for="time in times"
      :opened="opened_id === time.id"
      @delete="deleteTime(time.id)"
    ></Time>
  </div>
</template>

<script>
import Time from '@/components/times/Time'
import { mapActions } from 'vuex/dist/vuex.common.js';

export default {
  components: { Time },
  props: ['times'],
  data: () => ({
    opened_id: null
  }),
  methods: {
    ...mapActions('player', [
      'seek'
    ]),
    ...mapActions('noti', [
      'info'
    ]),
    ...mapActions('videos', [
      'deleteTimeAdmin'
    ]),
    deleteTime(id) {
      this.deleteTimeAdmin(id)
        .then(() => {
          this.info('Aika poistettu')
        })
    },
    toggle(id) {
      const open_this = this.opened_id !== id
      this.opened_id = open_this ? id : null

      if(open_this) {
        this.seekToStart(id)
      }
    },
    seekToStart(id) {
      const time = this.times.find(t => t.id === id)

      this.seek(time.first_time_video_time - 2)
    }
  }

}
</script>